import React, { useState } from "react";
import DashboardLayout from "../Layout/DashboardLayout";
import Breadcrumbs from "../Components/Dashboard/Breadcrumbs";
import CoverImg from "../Assets/CoverImg.png";
import TeamImg from "../Assets/TeamProfile.png";
import { ReactComponent as CameraIcon } from "../Assets/Icons/cameraIcon.svg";
import StateIcon from "../Assets/Icons/stateIcon.svg";
import ProjectTypeIcon from "../Assets/Icons/projectIcon.svg";
import MatchIcon from "../Assets/Icons/matchIcon.svg";
import TaskIcon from "../Assets/Icons/taskIcon.svg";
import PenIcon from "../Assets/Icons/panIcon.svg";
import EyeIcon from "../Assets/Icons/eyeBlack.svg";
import ShareIcon from "../Assets/Icons/shareIcon.svg";
import PlusIcon from "../Assets/Icons/plusIcon.svg";
import TeamMemberCard from "../Components/AITeam/TeamMemberCard";
import PeopleAvatar from "../Assets/PeopleAvatar.png";
import CompanyAvatar from "../Assets/CompanyAvatar.png";
import PreviousProject from "../Components/AITeam/PreviousProject";
import ProjectImg from "../Assets/ProjectImg.png";
import Tags from "../Components/AITeam/Tags";
import CloseIcon from "../Assets/Icons/closeIcon.svg";
import TagsImg from "../Assets/Icons/financialIcon.svg";
import UniIcon from "../Assets/UniAvatar.png";
import UniversalCard from "../Components/AITeam/UniversalCard";
import FrameWorkIcon from "../Assets/FrameworkAvatar.png";
import AiTeamModal from "../Components/AiTeamModal";
import ShareTeamProfileModal from "../Components/ShareTeamProfileModal";
import AiTeamSideBar from "../Components/AITeam/AiTeamSideBar";
import SqlIcon from "../Assets/sql.png";
import RIcon from "../Assets/rIcon.png";
import SparkIcon from "../Assets/spark.png";
import PyTorch from "../Assets/pytorchIcon.png";
import HtmlIcon from "../Assets/HTML Daimlas.png";
import CssIcon from "../Assets/CSS Daimlas.png";
import AngularIcon from "../Assets/Angular Daimlas.png";
import BootstrapIcon from "../Assets/Bootstrap Daimlas.png";
import JavaIcon from "../Assets/Java Daimlas.png";
import NodeIcon from "../Assets/Node Daimlas.png";
import PythonIcon from "../Assets/Python Daimlas.png";
import RedisIcon from "../Assets/Redis Daimlas.png";
import MIcrosoftSql from "../Assets/Microsoft SQL Server Daimlas.png";
import MonogoDb from "../Assets/MongoDB Daimlas.png";
import MySqlIcon from "../Assets/MySQL Daimlas.png";
import NeoIcon from "../Assets/Neo4j Daimlas.png";
import DockerIcon from "../Assets/Docker Daimlas.png";
import AzureIcon from "../Assets/Azure Daimlas.png";
import ChefIcon from "../Assets/Chef Daimlas.png";
import BladeIcon from "../Assets/Bladecenter Daimlas.png";
import KotlinIcon from "../Assets/Kotlin Daimlas.png";
import SwiftIcon from "../Assets/Swift Daimlas.png";
import PwaIcon from "../Assets/PWA Daimlas.png";
import ObjectiveC from "../Assets/Objective-C Daimlas.png";
import IndustryIcon from "../Assets/IndustryIcon.png";
import IndustryIconTwo from "../Assets/IndustryIcon1.png";
import IndustryIconThree from "../Assets/IndustryIcon2.png";
import IndustryIconFour from "../Assets/IndustryIcon3.png";
import IndustryIconFive from "../Assets/Biology, Health and Medicine.png";
import IndustryIconSix from "../Assets/Business Analysis.png";
import IndustryIconSeven from "../Assets/Business Process Redesign.png";
import IndustryIconEight from "../Assets/Change Management.png";
import industryIconNine from "../Assets/Brand _ Marketing Strategy.png";
import IndustrialIconTen from "../Assets/4_Chinchilla.png";
import IndustrialIconEleven from "../Assets/4_GPT-3.png";
import IndustrialIconTwelve from "../Assets/4_GPT-4.png";
import IndustrialIconThirteen from "../Assets/4_Claude.png";
import IndustrialIconFourteen from "../Assets/Analytics.png";
import IndustrialIconFifteen from "../Assets/Blockchain.png";
import IndustrialIconSixteen from "../Assets/Business Intelligence.png";
import IndustrialIconSeventeen from "../Assets/Data Engineering.png";
import IndustrialIconEighteen from "../Assets/CRM, ERP, Accounting, Operations, Marketing Automation.png";
import IndustrialIconNineteen from "../Assets/Matplotlib Daimlas.png";
import IndustrialIconTwenteen from "../Assets/NLTK Daimlas.png";
import IndustrialIconTwentyOne from "../Assets/NumPy Daimlas.png";
import IndustrialIconTwentyTwo from "../Assets/Pandas Daimlas.png";
import IndustrialIconTwentyThree from "../Assets/Amazon SageMaker Daimlas.png";
import IndustrialIconTwentyFour from "../Assets/DataRobot Daimlas.png";
import IndustrialIconTwentyFive from "../Assets/Looker Daimlas.png";
import IndustrialIconTwentySix from "../Assets/Google Cloud Daimlas.png";
import RoboticIcon from "../Assets/Robotic Process Automation (RPA).png";
import BigDataIcon from "../Assets/Big Data and Cloud.png";
import BlockchainIcon from "../Assets/Blockchain Technologies.png";
import BusinessIcon from "../Assets/Business Intelligence and Visualization.png";
import ChatbotIcon from "../Assets/Chatbot and Voice Assistant.png";
import ComplexCodeIcon from "../Assets/Daimlas Complex Code Bases.png";
import ComputerScienceIcon from "../Assets/Daimlas Computer Science Fundamentals.png";
import DataStructureIcon from "../Assets/Daimlas Data Structures.png";
import DeepLearningIcon from "../Assets/Daimlas Deep Learning Frameworks.png";
import LargeSystemsIcon from "../Assets/Daimlas Large Systems.png";
import DevOpsIcon from "../Assets/Daimlas Dev Ops.png";
import FrontEndIcon from "../Assets/Daimlas Front End.png";
import FullStackIcon from "../Assets/Daimlas Full Stack.png";
import MlOpsIcon from "../Assets/Daimlas ML Ops.png";
import MobileIcon from "../Assets/Daimlas Mobile.png";
import AddTechModal from "../Components/TeamProfileModals/AddTechModals";
import SubjectMatterExpertModal from "../Components/TeamProfileModals/SubjectMatterExpertModal";
import PreviousProjectModal from "../Components/TeamProfileModals/PreviousProject";
import CompanyYouWorkForModal from "../Components/TeamProfileModals/CompanyYouWorkFor";

export default function AiTeam() {
  const [openModal, setOpenModal] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openMl, setOpenMl] = useState(false);
  const [openFrontEnd, setOpenFrontEnd] = useState(false);
  const [openBackEnd, setOpenBackEnd] = useState(false);
  const [openDataBase, setOpenDataBase] = useState(false);
  const [openDevOps, setOpenDevOps] = useState(false);
  const [openMobileApps, setOpenMobileApps] = useState(false);
  const [openBasedOnRoles, setOpenBasedOnRoles] = useState(false);
  const [openDeepUnderstanding, setOpenDeepUnderstanding] = useState(false);
  const [openTechnologyTools, setOpenTechnologyTools] = useState(false);
  const [openTechnicalFunction, setOpenTechnicalFunction] = useState(false);
  const [openLargeLanguaageModel, setOpenLargeLanguageModel] = useState(false);
  const [openBusinessFunction, setOpenBusinessFunction] = useState(false);
  const [openIndustry, setOpenIndustry] = useState(false);
  const [openSubjectExpert, setOpenSubjectExpert] = useState(false);
  const [openCompanyModal, setOpenCompanyModal] = useState(false);
  const [openPreviousProject, setOpenPreviousProject] = useState(false);
  const [openDataScience, setOpenDataScience] = useState(false);
  const [openCloudVendor, setOpenCloudVendor] = useState(false);

  return (
    <div style={{ position: openModal ? "fixed" : "static" }}>
      <DashboardLayout>
        <section className="bg-white py-4 px-6 gap-y-5 w-full flex flex-col items-start">
          <Breadcrumbs links={[{ name: "Team Profile", link: "dsads" }]} />
          <SubjectMatterExpertModal
            open={openSubjectExpert}
            setOpen={setOpenSubjectExpert}
          />
          <CompanyYouWorkForModal
            open={openCompanyModal}
            setOpen={setOpenCompanyModal}
          />
          <PreviousProjectModal
            open={openPreviousProject}
            setOpen={setOpenPreviousProject}
          />
          <AddTechModal
            open={openMl}
            setOpen={setOpenMl}
            modalheading="Add Machine Learning Framework"
            dropdowntext="Choose Machine Learning Framework"
            dropdownoptions={[
              "Amazon Machine Learning",
              "AutoCAD",
              "C#",
              "Databricks",
              "Keras",
              "Matlab",
              "Spark",
              "TensorFlow",
              "Microsoft Cognitive Toolkit",
              "SQL",
              "R",
              "Scikit Learn",
              "PyTorch",
              "Tableau",
              "Other",
            ]}
          />
          <AddTechModal
            open={openFrontEnd}
            setOpen={setOpenFrontEnd}
            modalheading="Add Front End"
            dropdowntext="Choose Front End"
            dropdownoptions={[
              "Angular",
              "Bootstrap",
              "CSS",
              "HTML",
              "JavaScript",
              "Material UI",
              "React",
              "Vue",
              "Webpack",
              "Other",
            ]}
          />
          <AddTechModal
            open={openDataBase}
            setOpen={setOpenDataBase}
            modalheading="Add Database"
            dropdowntext="Choose Database"
            dropdownoptions={[
              "ArangoDb",
              "Cassandra",
              "CouchDB",
              "ElasticSearch",
              "Kafka",
              "Microsoft SQL Server",
              "MongoDB",
              "MySQL",
              "Neo4j",
              "Oracle",
              "PostgreSQL",
              "Redis",
              "SQS",
              "ZeroMQ",
              "Other",
            ]}
          />
          <AddTechModal
            open={openDevOps}
            setOpen={setOpenDevOps}
            modalheading="Add DevOps"
            dropdowntext="Choose DevOps"
            dropdownoptions={[
              "AWS",
              "Azure",
              "Ansible",
              "BladeCenter",
              "Chef",
              "Docker",
              "ELK",
              "Jenkins",
              "Kubernetes",
              "NGINX",
              "VMware",
              "Other",
            ]}
          />
          <AddTechModal
            open={openMobileApps}
            setOpen={setOpenMobileApps}
            modalheading="Add Mobile App"
            dropdowntext="Choose Mobile App"
            dropdownoptions={[
              "Ionic",
              "Java",
              "Kotlin",
              "Objective-C",
              "PWA",
              "React Native",
              "SDQ",
              "Swift",
              "Xamarin",
              "Other",
            ]}
          />
          <AddTechModal
            open={openBackEnd}
            setOpen={setOpenBackEnd}
            modalheading="Add Back End"
            dropdowntext="Choose Back End"
            dropdownoptions={[
              "ASP.NET",
              "Java",
              "Node",
              "Python",
              "Ruby on Rails",
              "Other",
            ]}
          />
          <AddTechModal
            open={openBasedOnRoles}
            setOpen={setOpenBasedOnRoles}
            modalheading="Add Based On Roles"
            dropdowntext="Choose a Based on roles"
            dropdownoptions={[
              "Ideation",
              "Exploration",
              "Development",
              "Deployment",
              "Explorium",
              "Full Stack",
              "Back End",
              "AI/ML",
              "MLOps",
              "DevOps",
              "Front End",
              "Mobile",
              "Other",
            ]}
          />
          <AddTechModal
            open={openDeepUnderstanding}
            setOpen={setOpenDeepUnderstanding}
            modalheading="Add Deep Understanding"
            dropdowntext="Choose a deep understanding"
            dropdownoptions={[
              "Compex Code Basis",
              "Large Systems",
              "Data Mining",
              "Predictive Modeling",
              "Algorithms",
              "Large Systems",
              "Data Structures",
              "Machine Learning Libraries",
              "Artificial Neural Networks",
              "Version Control System",
              "Pattern Recognition",
              "Recommendation Systems",
              "Deep Learning Frameworks",
              "Computer Science Fundamentals",
              "Other",
            ]}
          />
          <AddTechModal
            open={openTechnologyTools}
            setOpen={setOpenTechnologyTools}
            modalheading="Add Technology and Tools"
            dropdowntext="Choose a technology and tools"
            dropdownoptions={[
              "Big Data and Cloud",
              "Blockchain Technology",
              "Business Intelligence and Visualization",
              "CRM",
              "ERP",
              "Accounting",
              "Operations",
              "Marketing Automation",
              "Chatbot and Voice Assistant",
              "Data analysis and AI Tools",
              "Data analysis in Biology",
              "Data Science",
              "Data Warehouse Appliance",
              "Design and Animation",
              "DevOps Tools",
              "Deep Learning",
              "Enterprise Information Archiving",
              "Enterprise Performance Management",
              "In-Memory Appliances",
              "Machine Learning Framework",
              "Mapping and GIS",
              "Master Data Management",
              "Programming Languages and Framework",
              "QA Tools",
              "Reinforcement Learning",
              "Robotics Process Automation (RPA)",
              "Security Analytics",
              "Web Analytics Platform",
              "Other",
            ]}
          />
          <AddTechModal
            open={openTechnicalFunction}
            setOpen={setOpenTechnicalFunction}
            modalheading="Add Technical Functions"
            dropdowntext="Choose a Technical Function"
            dropdownoptions={[
              "Analytics",
              "Analytics Blockchain",
              "Business Intelligence",
              "Security Analytics",
              "CRM",
              "ERP",
              "Accounting",
              "Operations",
              "Marketing Automation",
              "Computational Biology",
              "Data Engineering",
              "Data Management",
              "Data Visualization",
              "Design, Devops",
              "Enterprise Performance Management",
              "Gaming analytics",
              "Internet of things",
              "Marketing and Web Analytics",
              "Mobile Apps",
              "Ontology and Semantic Technology",
              "Quality Assurance",
              "Robotics",
              "Robotic Process Automation",
              "Security Analytics",
              "Software and Web Development",
              "Speech and Voice Analytics",
              "Other",
            ]}
          />
          <AddTechModal
            open={openLargeLanguaageModel}
            setOpen={setOpenLargeLanguageModel}
            modalheading="Add Large Language Models"
            dropdowntext="Choose a Large Language Model"
            dropdownoptions={[
              "GPT-4",
              "Falcon",
              "GPT-3",
              "Bert",
              "GPT-2",
              "GPT-Neo",
              "GPT-J",
              "Megatron-Turing NLG",
              "Ernie 3.0 Titan",
              "Claude",
              "GLAM( Generalist Language Model)",
              "Gopher",
              "LaMDA ( Language Models for Dialog Application)",
              "GPT-NeoX",
              "Chinchilla",
              "PaLM ( Pathway Language Model)",
              "OPT (Open Pretrained Transformer)",
              "YaLM 100B",
              "Minerva",
              "BLOOM",
              "Alexa ™ (Teacher Models)",
              "LLaMa ( Large Language Model Meta AI)",
              "Cerebras GPT",
              "Other",
            ]}
          />
          <AddTechModal
            open={openBusinessFunction}
            setOpen={setOpenBusinessFunction}
            modalheading="Add Specializations and Business Functions"
            dropdowntext="Choose a specializations or Business functions"
            dropdownoptions={[
              "Finance",
              "Financial Planning & Analysis",
              "Consumer Experience",
              "Strategic Business Planning",
              "Go-to-Market & Market Growth Strategy",
              "Biology Health Care and Medicine",
              "Brand and Marketing Strategy",
              "Business Analysis",
              "Business Process Redesign",
              "Change Management",
              "Chemistry",
              "Consumer Experience",
              "Customer Analytics",
              "Due Diligence",
              "Engineering and design",
              "Exploration and production",
              "General Management Consulting",
              "Human Ressources",
              "Managed Markets",
              "Market Research",
              "Marketing",
              "Media and Advertising",
              "Mergers and Acquisitions Strategy",
              "Physical Science",
              "Pricing and Actuarial",
              "Project Management",
              "R&D",
              "Risk and Compliance",
              "Sales",
              "Security and Operations",
              "Social Media",
              "Social Sciences",
              "Startegic Business Planning",
              "Supply Chain and Logistics",
              "Technical Writing",
              "Voice of Customer Research",
              "Other",
            ]}
          />
          <AddTechModal
            open={openIndustry}
            setOpen={setOpenIndustry}
            modalheading="Add Industry"
            dropdowntext="Choose an industry"
            dropdownoptions={[
              "Aerospace",
              "Agriculture",
              "Automotive",
              "Chemical, Oil and Gas",
              "Consumer Goods and Retail",
              "Education",
              "Energy and Utility",
              "Financial Services",
              "Healthcare",
              "Hi-Tech",
              "Hospitality, Travel and Leisure",
              "Insurance",
              "Legal",
              "Manufacturing",
              "Media and Advertising",
              "Non-Profit",
              "Pharmaceutical and Life Sciences",
              "Politics",
              "Professional Services",
              "Public Service",
              "Real Estate",
              "Social Sciences and Development",
              "Software",
              "Sports and Fitness",
              "Telecommunications",
              "Transportation and Warehousing",
              "Other",
              "Risk and Compliance",
              "Sales",
              "Security and Operations",
              "Social Media",
              "Social Sciences",
              "Startegic Business Planning",
              "Supply Chain and Logistics",
              "Technical Writing",
              "Voice of Customer Research",
              "Other",
            ]}
          />
          <AddTechModal
            open={openIndustry}
            setOpen={setOpenIndustry}
            modalheading="Add Industry"
            dropdowntext="Choose an industry"
            dropdownoptions={[
              "Aerospace",
              "Agriculture",
              "Automotive",
              "Chemical, Oil and Gas",
              "Consumer Goods and Retail",
              "Education",
              "Energy and Utility",
              "Financial Services",
              "Healthcare",
              "Hi-Tech",
              "Hospitality, Travel and Leisure",
              "Insurance",
              "Legal",
              "Manufacturing",
              "Media and Advertising",
              "Non-Profit",
              "Pharmaceutical and Life Sciences",
              "Politics",
              "Professional Services",
              "Public Service",
              "Real Estate",
              "Social Sciences and Development",
              "Software",
              "Sports and Fitness",
              "Telecommunications",
              "Transportation and Warehousing",
              "Other",
              "Risk and Compliance",
              "Sales",
              "Security and Operations",
              "Social Media",
              "Social Sciences",
              "Startegic Business Planning",
              "Supply Chain and Logistics",
              "Technical Writing",
              "Voice of Customer Research",
              "Other",
            ]}
          />
          <AddTechModal
            open={openDataScience}
            setOpen={setOpenDataScience}
            modalheading="Add DataScience ToolKits"
            dropdowntext="Choose datascience toolkits"
            dropdownoptions={[
              "NumPy",
              "Pandas",
              "Matplotlib",
              "NLTK",
              "Scikit-learn",
              "SciPy",
              "Other",
            ]}
          />
           <AddTechModal
            open={openCloudVendor}
            setOpen={setOpenCloudVendor}
            modalheading="Add Cloud Vendor Experience"
            dropdowntext="Choose cloud vendor experience"
            dropdownoptions={[
              "Alteryx",
              "Amazon SageMaker",
              "DataRobot",
              "Databricks",
              "Google Cloud",
              "IBM Watson",
              "Looker",
              "Sas",
              "Machine Learning",
              "Microsoft Azure Cognitive Services",
              "Other"
            ]}
          />
          <AiTeamModal open={openEdit} setOpen={setOpenEdit} />
          {openModal && (
            <div className="absolute z-20 top-0 left-0 w-full h-screen overflow-hidden bg-black bg-opacity-75">
              <AiTeamSideBar setOpenModal={setOpenModal} />
            </div>
          )}
          <div className="w-full">
            <div
              style={{ backgroundImage: `url(${CoverImg})` }}
              className="w-full h-[22rem] bg-no-repeat bg-cover rounded-[8px] flex items-start justify-end p-3"
            >
              <CameraIcon stroke="black" />
            </div>
            <div className="flex items-center justify-center mt-[-70px]">
              <div
                style={{ backgroundImage: `url(${TeamImg})` }}
                className="w-[10rem] h-[10.1rem] bg-no-repeat bg-cover rounded-[8px] flex items-center justify-center pt-36 p-3 rounded-full"
              >
                <CameraIcon stroke="white" />
              </div>
            </div>
            <div className="flex items-center flex-col justify-center gap-[5px] mt-3">
              <p className="text-[1.25rem] text-[#111928] font-bold">
                Al in Workforce Development Team
              </p>
              <p className="text-[1rem] text-[#6B7280]">Riyadh</p>
              <p className="text-[1rem] text-[#942A27]">
                Assigned Al Project <span className="text-[#6B7280]">:</span>{" "}
                First AI Project
              </p>
              <p className="text-[0.875rem] text-[#6B7280]">
                Joined Since: July 15, 2022
              </p>
            </div>
            <div className="flex items-center justify-center gap-4 mt-5">
              <button className="bg-[#E5E7EB] w-[9.4rem] py-2 text-[0.94rem] text-[#1F2A37] font-[500] rounded-[8px] flex items-center justify-center gap-2">
                <img src={ProjectTypeIcon} /> Al Projects
              </button>
              <button className="bg-[#E5E7EB] w-[9.4rem] py-2 text-[0.94rem] text-[#1F2A37] font-[500] rounded-[8px] flex items-center justify-center gap-2">
                <img src={TaskIcon} /> My Tasks
              </button>
              <button
                className="bg-[#E5E7EB] w-[9.4rem] py-2 text-[0.94rem] text-[#1F2A37] font-[500] rounded-[8px] flex items-center justify-center gap-2"
                onClick={() => setOpenModal(true)}
              >
                <img src={PenIcon} /> Edit Profile
              </button>
              <button className="bg-[#E5E7EB] w-[9.4rem] py-2 text-[0.94rem] text-[#1F2A37] font-[500] rounded-[8px] flex items-center justify-center gap-2">
                <img src={EyeIcon} /> Preview Profile
              </button>
            </div>
          </div>
        </section>
        <section className="bg-[#F9FAFB] py-4 px-6 gap-y-5 w-full flex items-start justify-between">
          <section className="w-[67%] py-4">
            <div className="flex items-center justify-between">
              <p className="text-[1rem] text-[#101828]">Team Members</p>
              <div className="flex items-center gap-2">
                <img src={PlusIcon} />
                <p className="text-[#942A27]">Add team member</p>
              </div>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="grid grid-cols-3 gap-4 mt-6">
              {[0, 1, 2, 3, 4, 5, 6, 7, 8].map((keys) => {
                return (
                  <TeamMemberCard
                    img={PeopleAvatar}
                    name="Roberta Casas"
                    position="Data Scientist"
                    btntext="Edit"
                    handleClick={() => setOpenEdit(true)}
                    closeicon={CloseIcon}
                    hourstext="Hours Available This Week:"
                    hours="40"
                  />
                );
              })}
            </div>
            <div className="flex items-center justify-between mt-12">
              <p className="text-[1rem] text-[#101828]">Companies worked for</p>
              <div
                onClick={() => setOpenCompanyModal(true)}
                className="flex items-center gap-2 cursor-pointer"
              >
                <img src={PlusIcon} />
                <p className="text-[#942A27]">Add a company</p>
              </div>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center justify-between flex-wrap gap-4 mt-6">
              {[0, 1, 2].map((keys) => {
                return (
                  <TeamMemberCard
                    img={CompanyAvatar}
                    name="Active.ai"
                    location="Singapore"
                    btntext="Edit Company"
                    closeicon={CloseIcon}
                  />
                );
              })}
            </div>
            <div className="flex items-center justify-between mt-12">
              <p className="text-[1rem] text-[#101828]">Previous Projects</p>
              <div
                onClick={() => setOpenPreviousProject(true)}
                className="flex items-center gap-2 cursor-pointer"
              >
                <img src={PlusIcon} />
                <p className="text-[#942A27]">
                  Add Previous Project Experience
                </p>
              </div>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center justify-between flex-wrap gap-4 mt-6">
              {[0, 1].map((keys) => {
                return (
                  <PreviousProject
                    projectimg={ProjectImg}
                    projecttitle="Project Title"
                    location="Riyadh"
                    closeicon={CloseIcon}
                    penicon={PenIcon}
                    desc="Mobile banking apps and web portals, financial service AI can analyze consumers’ individual account data to see what they have, how they’re performing financially, make recommendations on future actions based on the results, and then help with automation for savings and budgeting for better financial health and behavior."
                  />
                );
              })}
            </div>
            <div className="flex items-center justify-between  mt-12">
              <p className="text-[1rem] text-[#101828]">
                Subject Matter Experts
              </p>
              <div
                onClick={() => setOpenSubjectExpert(true)}
                className="flex items-center gap-2 cursor-pointer"
              >
                <img src={PlusIcon} />
                <p className="text-[#942A27]">Subject Matter Expert</p>
              </div>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center justify-between flex-wrap gap-4 mt-6">
              {[0, 1, 2].map((keys) => {
                return (
                  <TeamMemberCard
                    img={PeopleAvatar}
                    name="John T"
                    location="New Jersey"
                    position="Data scientist"
                    btntext="View Profile"
                    closeicon={CloseIcon}
                  />
                );
              })}
            </div>
            <div className="flex items-center justify-between  mt-12">
              <p className="text-[1rem] text-[#101828]">Industry</p>
              <div
                onClick={() => setOpenIndustry(true)}
                className="flex items-center gap-2 cursor-pointer"
              >
                <img src={PlusIcon} />
                <p className="text-[#942A27]">Add industry</p>
              </div>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center flex-wrap gap-3 mt-6">
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustryIcon}
                tagstext="Aerospace"
              />
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustryIconTwo}
                tagstext="Agriculture"
              />
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustryIconFour}
                tagstext="Chemical, oil and gas"
              />
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustryIconThree}
                tagstext="Automotive"
              />
              <Tags
                closeicon={CloseIcon}
                tagsimg={TagsImg}
                tagstext="Energy and Utility"
              />
            </div>
            <div className="flex items-center justify-between  mt-12">
              <p className="text-[1rem] text-[#101828]">
                Specialization and Business Function
              </p>
              <div
                onClick={() => setOpenBusinessFunction(true)}
                className="flex items-center gap-2 cursor-pointer"
              >
                <img src={PlusIcon} />
                <p className="text-[#942A27]">
                  Add specialization or business function
                </p>
              </div>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center flex-wrap gap-3 mt-6">
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustryIconFive}
                tagstext="Biology, Health and Medicine"
              />
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustryIconSix}
                tagstext="Business Analysis"
              />
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustryIconSeven}
                tagstext="Business Process Redesign"
              />
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustryIconEight}
                tagstext="Change Mangement"
              />
              <Tags
                closeicon={CloseIcon}
                tagsimg={industryIconNine}
                tagstext="Brand Marketing Strategy"
              />
            </div>
            <div className="flex items-center justify-between  mt-12">
              <p className="text-[1rem] text-[#101828]">
                Foundational Models / LLM's
              </p>
              <div
                onClick={() => setOpenLargeLanguageModel(true)}
                className="flex items-center gap-2 cursor-pointer"
              >
                <img src={PlusIcon} />
                <p className="text-[#942A27]">Add large language models</p>
              </div>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center flex-wrap gap-3 mt-6">
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustrialIconTen}
                tagstext="Chinchilla"
              />
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustrialIconEleven}
                tagstext="GPT-3"
              />
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustrialIconTwelve}
                tagstext="GPT-4"
              />
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustrialIconThirteen}
                tagstext="Claude"
              />
            </div>
            <div className="flex items-center justify-between  mt-12">
              <p className="text-[1rem] text-[#101828]">Technical Function</p>
              <div
                onClick={() => setOpenTechnicalFunction(true)}
                className="flex items-center gap-2 cursor-pointer"
              >
                <img src={PlusIcon} />
                <p className="text-[#942A27]">Add technical function</p>
              </div>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center flex-wrap gap-3 mt-6">
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustrialIconFourteen}
                tagstext="Analytics"
              />
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustrialIconSixteen}
                tagstext="Business Intelligence"
              />
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustrialIconSeventeen}
                tagstext="Data Engineering"
              />
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustrialIconEighteen}
                tagstext="CRM"
              />
              <Tags
                closeicon={CloseIcon}
                tagsimg={IndustrialIconFifteen}
                tagstext="Blockchain"
              />
            </div>
            <div className="flex items-center justify-between  mt-12">
              <p className="text-[1rem] text-[#101828]">Technology and Tools</p>
              <div
                onClick={() => setOpenTechnologyTools(true)}
                className="flex items-center gap-2 cursor-pointer"
              >
                <img src={PlusIcon} />
                <p className="text-[#942A27]">Add technology and tools</p>
              </div>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center flex-wrap gap-3 mt-6">
              {[
                {
                  name: "Big Data",
                  icon: BigDataIcon,
                },
                {
                  name: "Blockchain",
                  icon: BlockchainIcon,
                },
                {
                  name: "Business Intelligence",
                  icon: BusinessIcon,
                },
                {
                  name: "Chatbot",
                  icon: ChatbotIcon,
                },
                {
                  name: "Robotic Process Automation",
                  icon: RoboticIcon,
                },
              ].map((item) => {
                return (
                  <Tags
                    closeicon={CloseIcon}
                    tagsimg={item.icon}
                    tagstext={item.name}
                  />
                );
              })}
            </div>
            <div className="flex items-center justify-between  mt-12">
              <p className="text-[1rem] text-[#101828]">Deep Understanding</p>
              <div
                onClick={() => setOpenDeepUnderstanding(true)}
                className="flex items-center gap-2 cursor-pointer"
              >
                <img src={PlusIcon} />
                <p className="text-[#942A27]">Add deep understanding</p>
              </div>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center flex-wrap gap-3 mt-6">
              {[
                {
                  name: "Complex Code Bases",
                  icon: ComplexCodeIcon,
                },
                {
                  name: "Science Fundamentals",
                  icon: ComputerScienceIcon,
                },
                {
                  name: "Data Structures",
                  icon: DataStructureIcon,
                },
                {
                  name: "Deep Learning Frameworks",
                  icon: DeepLearningIcon,
                },
                {
                  name: "Large Systems",
                  icon: LargeSystemsIcon,
                },
              ].map((item) => {
                return (
                  <Tags
                    closeicon={CloseIcon}
                    tagsimg={item.icon}
                    tagstext={item.name}
                  />
                );
              })}
            </div>
            <div className="flex items-center justify-between  mt-12">
              <p className="text-[1rem] text-[#101828]">Based on Roles</p>
              <div
                onClick={() => setOpenBasedOnRoles(true)}
                className="flex items-center gap-2 cursor-pointer"
              >
                <img src={PlusIcon} />
                <p className="text-[#942A27]">Add based on roles</p>
              </div>
            </div>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
            <div className="flex items-center flex-wrap gap-3 mt-6">
              {[
                {
                  name: "Dev Ops",
                  icon: DevOpsIcon,
                },
                {
                  name: "Front End",
                  icon: FrontEndIcon,
                },
                {
                  name: "Full Stack",
                  icon: FullStackIcon,
                },
                {
                  name: "ML Ops",
                  icon: MlOpsIcon,
                },
                {
                  name: "Mobile",
                  icon: MobileIcon,
                },
              ].map((item) => {
                return (
                  <Tags
                    closeicon={CloseIcon}
                    tagsimg={item.icon}
                    tagstext={item.name}
                  />
                );
              })}
            </div>
            {/* <div className="flex items-center justify-between  mt-12">
            <p className="text-[1rem] text-[#101828]">Applied Statistics</p>
            <div className="flex items-center gap-2">
              <img src={PlusIcon} />
              <p className="text-[#942A27]">Add applied statistics</p>
            </div>
          </div> */}
            {/* <div className="w-full h-[1px] bg-[#EAECF0] mt-4"></div>
          <div className="flex items-center flex-wrap gap-3 mt-6">
            {[0, 1, 2, 3, 4].map((keys) => {
              return (
                <Tags
                  closeicon={CloseIcon}
                  tagsimg={TagsImg}
                  tagstext="Energy and Utility"
                />
              );
            })}
          </div> */}
          </section>
          <section className="w-[30%] py-4 ">
            {/* <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px]">
            <p>Team Members Schools</p>
            <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
            <div className="flex flex-col gap-3 mt-3">
              {[0, 1, 2, 3].map((keys) => {
                return (
                  <UniversalCard
                    img={UniIcon}
                    name="University of Tennessee"
                    location="Nashville, TN, USA"
                    closeicon={CloseIcon}
                    penicon={PenIcon}
                  />
                );
              })}
            </div>
            <div className="mt-3">
              <button className="w-full py-2 rounded-[8px] border-[1px] border-dashed border-[#9CA3AF] text-[0.94rem] font-[500] text-[#1F2A37]">
                Add education
              </button>
            </div>
          </div> */}
            <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px] mt-3">
              <p>Machine Learning Frameworks</p>
              <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
              <div className="flex flex-col gap-3 mt-3">
                <UniversalCard
                  img={SparkIcon}
                  name="Spark"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="22px"
                  height="11px"
                />
                <UniversalCard
                  img={RIcon}
                  name="R Prokject"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="22px"
                  height="15px"
                />
                <UniversalCard
                  img={PyTorch}
                  name="Pytorch"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="22px"
                  height="8px"
                />
                <UniversalCard
                  img={SqlIcon}
                  name="Sql"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="15px"
                  height="20px"
                />
              </div>
              <div className="mt-3">
                <button
                  onClick={() => setOpenMl(true)}
                  className="w-full py-2 rounded-[8px] border-[1px] border-dashed border-[#9CA3AF] text-[0.94rem] font-[500] text-[#1F2A37]"
                >
                  Add machine learning framework
                </button>
              </div>
            </div>
            <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px] mt-3">
              <p>Front End</p>
              <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
              <div className="flex flex-col gap-3 mt-3">
                <UniversalCard
                  img={HtmlIcon}
                  name="HTML"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={CssIcon}
                  name="CSS"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={BootstrapIcon}
                  name="Bootstrap"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="18px"
                  height="20px"
                />
                <UniversalCard
                  img={AngularIcon}
                  name="Angular"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="18px"
                  height="20px"
                />
              </div>
              <div className="mt-3">
                <button
                  onClick={() => setOpenFrontEnd(true)}
                  className="w-full py-2 rounded-[8px] border-[1px] border-dashed border-[#9CA3AF] text-[0.94rem] font-[500] text-[#1F2A37]"
                >
                  Add front end
                </button>
              </div>
            </div>
            <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px] mt-3">
              <p>Back End</p>
              <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
              <div className="flex flex-col gap-3 mt-3">
                <UniversalCard
                  img={PythonIcon}
                  name="Python"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="17px"
                  height="17px"
                />
                <UniversalCard
                  img={JavaIcon}
                  name="Java"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="17px"
                  height="17px"
                />
                <UniversalCard
                  img={NodeIcon}
                  name="NodeJs"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="17px"
                  height="17px"
                />
                <UniversalCard
                  img={RedisIcon}
                  name="Redis"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="17px"
                  height="17px"
                />
              </div>
              <div className="mt-3">
                <button
                  onClick={() => setOpenBackEnd(true)}
                  className="w-full py-2 rounded-[8px] border-[1px] border-dashed border-[#9CA3AF] text-[0.94rem] font-[500] text-[#1F2A37]"
                >
                  Add back end
                </button>
              </div>
            </div>
            <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px] mt-3">
              <p>Database</p>
              <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
              <div className="flex flex-col gap-3 mt-3">
                <UniversalCard
                  img={MonogoDb}
                  name="MongoDB"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="16px"
                  height="16px"
                />
                <UniversalCard
                  img={NeoIcon}
                  name="Neo"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="16px"
                  height="16px"
                />
                <UniversalCard
                  img={MySqlIcon}
                  name="MySQL"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="16px"
                  height="16px"
                />
                <UniversalCard
                  img={MIcrosoftSql}
                  name="Microsoft SQL"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="18px"
                  height="18px"
                />
              </div>
              <div className="mt-3">
                <button
                  onClick={() => setOpenDataBase(true)}
                  className="w-full py-2 rounded-[8px] border-[1px] border-dashed border-[#9CA3AF] text-[0.94rem] font-[500] text-[#1F2A37]"
                >
                  Add database
                </button>
              </div>
            </div>
            <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px] mt-3">
              <p>DevOps</p>
              <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
              <div className="flex flex-col gap-3 mt-3">
                <UniversalCard
                  img={DockerIcon}
                  name="Docker"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={ChefIcon}
                  name="Chef"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={AzureIcon}
                  name="Azure"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={BladeIcon}
                  name="IBM"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
              </div>
              <div className="mt-3">
                <button
                  onClick={() => setOpenDevOps(true)}
                  className="w-full py-2 rounded-[8px] border-[1px] border-dashed border-[#9CA3AF] text-[0.94rem] font-[500] text-[#1F2A37]"
                >
                  Add devops
                </button>
              </div>
            </div>
            <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px] mt-3">
              <p>Mobile App</p>
              <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
              <div className="flex flex-col gap-3 mt-3">
                <UniversalCard
                  img={KotlinIcon}
                  name="Kotlin"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={ObjectiveC}
                  name="ObjectiveC"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={PwaIcon}
                  name="PWA"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={SwiftIcon}
                  name="Swift"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
              </div>
              <div className="mt-3">
                <button
                  onClick={() => setOpenMobileApps(true)}
                  className="w-full py-2 rounded-[8px] border-[1px] border-dashed border-[#9CA3AF] text-[0.94rem] font-[500] text-[#1F2A37]"
                >
                  Add mobile app
                </button>
              </div>
            </div>
            <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px] mt-3">
              <p>Data Science Toolkits</p>
              <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
              <div className="flex flex-col gap-3 mt-3">
                <UniversalCard
                  img={IndustrialIconNineteen}
                  name="Matplotlib"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={IndustrialIconTwenteen}
                  name="Natural Language Toolkit"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={IndustrialIconTwentyOne}
                  name="NumPy"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={IndustrialIconTwentyTwo}
                  name="Pandas"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
              </div>
              <div className="mt-3">
                <button
                  onClick={() => setOpenDataScience(true)}
                  className="w-full py-2 rounded-[8px] border-[1px] border-dashed border-[#9CA3AF] text-[0.94rem] font-[500] text-[#1F2A37]"
                >
                  Add data science toolkits
                </button>
              </div>
            </div>
            <div className="w-full py-3 px-3 bg-white border-[1px] border-[#E5E7EB] rounded-[12px] mt-3">
              <p>Cloud Vendor Experience</p>
              <div className="w-full h-[1px] bg-[#EAECF0] mt-2"></div>
              <div className="flex flex-col gap-3 mt-3">
                <UniversalCard
                  img={IndustrialIconTwentyThree}
                  name="Amazon SageMaker"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={IndustrialIconTwentyFour}
                  name="DataRobot"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={IndustrialIconTwentyFive}
                  name="Looker"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
                <UniversalCard
                  img={IndustrialIconTwentySix}
                  name="Google Cloud"
                  closeicon={CloseIcon}
                  penicon={PenIcon}
                  width="20px"
                  height="20px"
                />
              </div>
              <div className="mt-3">
                <button
                  onClick={() => setOpenCloudVendor(true)}
                  className="w-full py-2 rounded-[8px] border-[1px] border-dashed border-[#9CA3AF] text-[0.94rem] font-[500] text-[#1F2A37]"
                >
                  Add cloud vendor experience
                </button>
              </div>
            </div>
          </section>
        </section>
      </DashboardLayout>
    </div>
  );
}
